module.exports = __webpack_public_path__ + "img/录音.99971212.svg";